import { BlockType } from '@teko/discovery';
import { BreadcrumbProps, Breadcrumbs, Container } from '@teko/ds-desktop';
import { HeadSection } from 'components/HeadSection';
import { usePersonalizeBlocks } from 'hooks';
import { t } from 'i18n';
import { useRouter } from 'next/router';
import React from 'react';
import { BlockPageProps, getBlockParams } from '../shared';
import { BlockPageContent } from './BlockPageContent';

export const EXCLUDE_BLOCK_TYPE = [
  BlockType.MEGA_MENU,
  BlockType.WIDE_THICK_BANNER,
  BlockType.HORIZONTAL_4_BANNER,
  BlockType.VERTICAL_2_BANNER,
  BlockType.LEFT_STICKY_BANNER,
  BlockType.RIGHT_STICKY_BANNER,
  BlockType.POPUP_BANNER,
];

export const BlockPage: React.FC<BlockPageProps> = ({
  blocks: serverBlocks,
  mapSSRProducts,
  cookedFilters,
  seoInfo,
  filterPrice,
  forceNoIndex = false,
  filters,
}: BlockPageProps) => {
  const router = useRouter();
  const { query } = router;
  const blockParams = getBlockParams(query);
  const { result: blocks, isLoading } = usePersonalizeBlocks(blockParams);

  // display breadcrumbs for brand/category page
  // this block api only returns metaTitle.
  // siteTitle is there, just in case.
  const siteTitle = seoInfo?.siteTitle || seoInfo?.metaTitle;
  const breadCrumbs: BreadcrumbProps[] | null = siteTitle
    ? [
        {
          link: '/',
          name: t('Trang chủ'),
        },
        {
          disabled: true,
          link: '#',
          name: siteTitle,
        },
      ]
    : null;

  return (
    <>
      <HeadSection
        {...seoInfo}
        noindex={forceNoIndex || !seoInfo?.canonical}
        title={seoInfo?.metaTitle || seoInfo?.siteTitle}
      />
      {breadCrumbs && (
        <Container>
          <Breadcrumbs breadcrumbs={breadCrumbs} paddingLeft="s16" />
        </Container>
      )}
      <BlockPageContent
        loadingBlocks={isLoading}
        blocks={blocks?.length ? blocks : serverBlocks || []}
        excludeBlockType={EXCLUDE_BLOCK_TYPE}
        mapSSRProducts={mapSSRProducts}
        cookedFilters={cookedFilters}
        filterPrice={filterPrice}
        filters={filters}
      />
    </>
  );
};
